var $b3b6b14f9e02defe$exports = {};
const $b3b6b14f9e02defe$var$myPromise = ()=>new Promise((resolve, reject)=>{
        setTimeout(()=>{
            if (Math.random() > 0.5) resolve({
                name: "Paweł"
            });
            else reject("buuuu");
        }, 1000);
    });
console.log($b3b6b14f9e02defe$var$myPromise);
console.log(1);
$b3b6b14f9e02defe$var$myPromise().then((value)=>{
    console.log(value);
}).catch((reason)=>{
    console.log(reason);
}).finally(()=>{
    console.log("koniec");
});
console.log(2);
const $b3b6b14f9e02defe$var$test = async ()=>{
    try {
        const myObject = await $b3b6b14f9e02defe$var$myPromise();
        console.log(myObject);
        console.log("test");
    } catch (e) {
        console.log(e);
    }
};
$b3b6b14f9e02defe$var$test();


//# sourceMappingURL=index.fa823402.js.map
